<div class="modal fade" id="dialogTrocarSenha" tabindex="-1" role="dialog" aria-labelledby="autorizacao"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header bg-primary text-white">
        <h5 class="modal-title" id="title">Troca de senha</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form id="troca-form" autocomplete="off">
          <div class="row">
            <div class="col-12">
              <img class="float-left" src="assets/img/global/lock_break.png" alt="email">
              <span>Informe sua senha atual e a nova senha.</span>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-12">
              <label for="senha1">Senha Atual</label>
              <input name="senhaAtual" [(ngModel)]="senhaAtual" type="password" class="form-control" id="senha1" autocomplete="off">
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <label for="senha2">Nova Senha</label>
              <input name="senhaNova" [(ngModel)]="senhaNova" type="password" class="form-control" id="senha2" autocomplete="off">
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button (click)="enviar()" type="button" class="btn btn-primary btn-sm" id="btnEnviar"
          data-dismiss="modal">Enviar</button>
        <button type="button" class="btn btn-link" id="btnCancelar" data-dismiss="modal">Cancelar</button>
      </div>
    </div>
  </div>
</div>
